<template>
  <div
      class="modal"
      tabindex="-1"
      role="dialog"
      id="general_settings_modal"
      data-bs-backdrop="false"
      data-bs-keyboard="false"
  >
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Applicatie instellingen</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <ul class="nav nav-tabs" role="tablist" id="gsm_tabbar-tablist">
            <li class="nav-item">
              <a
                  class="nav-link active"
                  id="gsm_tabbar_general-tab"
                  role="tab"
                  data-bs-toggle="tab"
                  aria-controls="gsm_tabbar_general"
                  v-bind:data-bs-target="'#gsm_tabbar_general'"
              >Algemeen</a>
            </li>
            <li class="nav-item">
              <a
                  class="nav-link"
                  id="gsm_tabbar_paper-tab"
                  role="tab"
                  data-bs-toggle="tab"
                  aria-controls="gsm_tabbar_paper"
                  v-bind:data-bs-target="'#gsm_tabbar_paper'"
              >Papier formaten</a>
            </li>
            <li class="nav-item">
              <a
                  class="nav-link"
                  id="gsm_tabbar_coordinates-tab"
                  role="tab"
                  data-bs-toggle="tab"
                  aria-controls="gsm_tabbar_coordinates"
                  v-bind:data-bs-target="'#gsm_tabbar_coordinates'"
              >Coördinaten</a>
            </li>
            <li class="nav-item">
              <a
                  class="nav-link"
                  id="gsm_tabbar_cardinal_directions-tab"
                  role="tab"
                  data-bs-toggle="tab"
                  aria-controls="gsm_tabbar_cardinal_directions"
                  v-bind:data-bs-target="'#gsm_tabbar_cardinal_directions'"
              >Windstreken</a>
            </li>
            <li class="nav-item">
              <a
                  class="nav-link"
                  id="gsm_tabbar_problem_solver-tab"
                  role="tab"
                  data-bs-toggle="tab"
                  aria-controls="gsm_tabbar_problem_solver"
                  v-bind:data-bs-target="'#gsm_tabbar_problem_solver'"
              >Oplosser</a>
            </li>
          </ul>
          <div class="tab-content">
            <div
                class="tab-pane show active"
                id="gsm_tabbar_general"
                role="tabpanel"
                aria-labelledby="gsm_tabbar_general-tab"
            >
              <div class="form-group">
                <label for="gsm_neighbour_overlap" class="form-label">Buurkaart overlap (mm)</label>
                <input type="number" min="0" class="form-control" id="gsm_neighbour_overlap" v-bind:value="neighbourOverlap">
              </div>

              <div class="form-group">
                <div class="form-check">
                  <input
                      class="form-check-input"
                      id="gsm_default_advanced_settings_mode"
                      type="checkbox"
                      value="1"
                      v-bind:checked="defaultAdvancedSettingsMode"
                      v-on:change="changeDefaultAdvancedSettingsMode()"
                  >
                  <label class="form-check-label" for="gsm_default_advanced_settings_mode">Geavanceerde instellingen standaard aan</label>
                </div>
              </div>

              <div class="form-group">
                <label for="gsm_default_elevation_mode" class="form-label">Hoogte functionaliteit</label>
                <select
                    class="form-select"
                    id="gsm_default_elevation_mode"
                    v-on:change="changeDefaultElevationMode"
                >
                  <option
                      v-for="(label, option) in ElevationModeOptionLabels"
                      v-bind:value="option"
                      v-bind:selected="defaultElevationMode.valueOf() === option"
                  >{{ label }}</option>
                </select>
              </div>
            </div>

            <div class="tab-pane"
                 id="gsm_tabbar_paper"
                 role="tabpanel"
                 aria-labelledby="gsm_tabbar_paper-tab"
            >

              <div class="table-responsive">
                <table class="table gsm-paper-list">
                  <thead>
                  <tr>
                    <th>Naam</th>
                    <th>Breedte (mm)</th>
                    <th>Hoogte (mm)</th>
                    <th></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr
                      v-for="paper in paperList"
                      :key="paper.name"
                      v-bind:id="'gsm-paper-' + paper.name"
                  >
                    <td>{{ paper.title }}</td>
                    <td>{{ paper.width }}</td>
                    <td>{{ paper.height }}</td>
                    <td>
                      <div class="text-center" v-if="isCustomPaper(paper)">
                        <button class="btn btn-sm btn-outline-secondary" type="button" v-on:click="deletePaper(paper)">
                          <svg width="1em" height="1em" viewBox="0 0 16 16" class="align-baseline bi bi-trash-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z"/>
                          </svg>
                        </button>
                      </div>
                    </td>
                  </tr>
                  <tr
                      v-if="addingPaper"
                      id="gsm-new-paper"
                  >
                    <td>
                      <input
                          class="form-control gsm-paper-title"
                          type="text"
                      />
                    </td>
                    <td>
                      <input
                          class="form-control gsm-paper-width"
                          type="number"
                          min="50"
                          max="2000"
                      />
                    </td>
                    <td>
                      <input
                          class="form-control gsm-paper-height"
                          type="number"
                          min="50"
                          max="2000"
                      />
                    </td>
                    <td class="text-center">
                      <div class="btn-group" role="group">
                        <button class="btn btn-sm btn-outline-secondary" type="button" v-on:click="cancelAdd">
                          <svg width="1em" height="1em" viewBox="0 0 16 16" class="align-baseline bi bi-x-square" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>
                            <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                          </svg>
                        </button>
                        <button class="btn btn-sm btn-primary" type="button" v-on:click="saveAdd">
                          <svg width="1em" height="1em" viewBox="0 0 16 16" class="align-baseline bi bi-check-square" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>
                            <path d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.235.235 0 0 1 .02-.022z"/>
                          </svg>
                        </button>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                  <tfoot>
                  <tr v-if="!addingPaper">
                    <td></td>
                    <td></td>
                    <td></td>
                    <td class="text-center">
                      <button class="btn btn-sm btn-primary" type="button" v-on:click="addPaper">
                        <svg width="1em" height="1em" viewBox="0 0 16 16" class="align-baseline bi bi-plus-square" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>
                          <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                        </svg>
                      </button>
                    </td>
                  </tr>
                  </tfoot>
                </table>
              </div>

            </div>

            <div
                class="tab-pane"
                id="gsm_tabbar_coordinates"
                role="tabpanel"
                aria-labelledby="gsm_tabbar_coordinates-tab"
            >
              <div class="table-responsive">
                <table class="table">
                  <thead>
                  <tr>
                    <th>Stelsel</th>
                    <th>Voorkeursnotatie</th>
                    <th>In puntenoverzicht</th>
                    <th>In coördinatenpaneel</th>
                  </tr>
                  <tr class="table-light">
                    <td class="bg-light bg-opacity-75"></td>
                    <td class="bg-light bg-opacity-75"></td>
                    <td class="bg-light bg-opacity-75"></td>
                    <td class="bg-light bg-opacity-75 text-center">
                      <div class="form-check d-inline-block">
                        <input
                            class="form-check-input"
                            id="gsm_coordinates_panel_selection_dynamic"
                            type="checkbox"
                            name="gsm_coordinates_panel_selection"
                            value="1"
                            v-model="coordinateSystemsInPanelDynamic"
                            title="Dynamisch"
                            v-on:change="setCoordinateSystemsInPanelDynamic()"
                        />
                        <label class="form-check-label" for="gsm_coordinates_panel_selection_dynamic">Dynamisch</label>
                      </div>
                    </td>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="coordinateInSystem in coordinateInSystems">
                    <td>{{ coordinateInSystem.name }}</td>
                    <td>
                      <select class="form-select" v-on:change="setPreferredCoordinateFormatName(coordinateInSystem.coordinate, $event.target.value)">
                        <option
                            v-for="(coordinate, formatName) in coordinateInSystem.formatted"
                            v-bind:value="formatName"
                            v-bind:selected="formatName === coordinateInSystem.preferredFormatName"
                        >{{ coordinate }}</option>
                      </select>
                    </td>
                    <td class="text-center">
                      <input
                          class="form-check-input align-middle"
                          v-bind:id="'gsm_coordinates_preferred_coordinate_system_' + coordinateInSystem.id"
                          type="radio"
                          name="gsm_coordinates_preferred_coordinate_system"
                          value="1"
                          v-bind:checked="coordinateInSystem.isPreferred"
                          title="Tonen in coördinatenpaneel"
                          v-on:change="setPreferredCoordinateSystem(coordinateInSystem.coordinateSystem)"
                      />
                    </td>
                    <td class="text-center">
                        <input
                            class="form-check-input align-middle"
                            v-bind:id="'gsm_coordinates_panel_selection_' + coordinateInSystem.id"
                            type="checkbox"
                            v-bind:name="'gsm_coordinates_panel_selection_' + coordinateInSystem.id"
                            value="1"
                            v-bind:checked="coordinateInSystem.inCoordinatePanelSystems"
                            title="Tonen in coördinatenpaneel"
                            v-on:change="setCoordinateSystemInPanel(coordinateInSystem.coordinateSystem, $event.target.checked)"
                            v-bind:disabled="coordinateSystemsInPanelDynamic"
                        />
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div
                class="tab-pane"
                id="gsm_tabbar_cardinal_directions"
                role="tabpanel"
                aria-labelledby="gsm_tabbar_cardinal_directions-tab"
            >
              <div class="row">
                <div class="col-lg-8">
                  <div class="form-group mt-2">
                    <label class="form-label mb-0">Aantal windstreken</label>
                    <div class="form-text mt-0 mb-2 fst-italic">Bij het tonen van windstreken, de notatie van dit aantal windstreken aanhouden</div>

                    <div class="form-check" v-for="valid_count in CardinalDirections.VALID_COUNTS">
                      <input
                          class="form-check-input"
                          type="radio"
                          name="gsm_cardinal_directions_count"
                          v-bind:id="'gsm_cardinal_directions_count_' + valid_count"
                          v-bind:value="valid_count"
                          v-bind:checked="cardinalDirectionsCount == valid_count"
                          v-on:change="changeCardinalDirections($event)"
                      >
                      <label class="form-check-label" v-bind:for="'gsm_cardinal_directions_count_' + valid_count">
                        {{ valid_count }} windstreken
                      </label>
                    </div>
                  </div>

                  <div class="form-group">
                    <label for="gsm_cardinal_directions_locale" class="form-label">Windstreken taal</label>
                    <select
                        class="form-select"
                        id="gsm_cardinal_directions_locale"
                        v-on:change="changeCardinalDirections($event)"
                    >
                      <option
                          v-for="(locale_name, locale) in CardinalDirections.LOCALES"
                          v-bind:value="locale"
                          v-bind:selected="cardinalDirectionsLocale === locale"
                      >{{ locale_name }}</option>
                    </select>
                  </div>
                </div>
                <div class="col-lg-4" v-html="cardinalDirectionsExampleSvg"></div>
              </div>
            </div>

            <div
                class="tab-pane"
                id="gsm_tabbar_problem_solver"
                role="tabpanel"
                aria-labelledby="gsm_tabbar_problem_solver-tab"
            >
              <p class="mt-3 fw-bold">Gebruik onderstaande functionaliteiten alleen als je problemen ondervindt met de applicatie.</p>

              <button type="button" class="btn btn-warning d-block mt-3 mb-1" v-on:click="clearCache">
                <svg width="1em" height="1em" viewBox="0 0 16 16" class="align-baseline bi bi-x-circle" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                  <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                </svg>
                Buffers legen
              </button>
              <p class="small fst-italic text-muted">Wis alle gebufferde kaartstukken en metadata, zowel downloads als renders. Opvolgende downloads zullen kaartstukken opnieuw downloaden vanaf bronservers.</p>

              <button type="button" class="btn btn-warning d-block mt-3 mb-1" v-on:click="resetStorage">
                <svg width="1em" height="1em" viewBox="0 0 16 16" class="align-baseline bi bi-x-circle" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                  <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                </svg>
                Voorkeuren wissen
              </button>
              <p class="small fst-italic text-muted">Wis alle opgeslagen werkruimtes, sjablonen en andere voorkeuren. Dit heeft geen effect op eerder gemaakte permanente links en korte links.</p>

              <button type="button" class="btn btn-danger d-block mt-3 mb-1" v-on:click="resetApplication">
                <svg width="1em" height="1em" viewBox="0 0 16 16" class="align-baseline bi bi-x-circle" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                  <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                </svg>
                Reset applicatie
              </button>
              <p class="small fst-italic text-muted">Wis alle opgeslagen werkruimtes, sjablonen, voorkeuren en buffers volledig. Dit kan in sommige browsers even duren. Dit heeft geen effect op eerder gemaakte permanente links en korte links.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Container, {ElevationModeOptionLabels} from "../Main/Container";
import $ from "jquery";
import UserInterface from "../Main/UserInterface";
import Paper, {CustomPaper} from "../Util/Paper";
import {strSlug} from "../Util/functions";
import {Tab} from "bootstrap";
import {bsModal} from "../Util/vueFunctions";
import {CardinalDirections} from "../Util/CardinalDirections.js";
import CoordinateSystem from "../Coordinates/CoordinateSystem.js";
import Coordinate from "../Coordinates/Coordinate.js";
import CoordinateConverter from "../Util/CoordinateConverter.js";
import WGS84 from "../Coordinates/WGS84.js";

export default {
  props: {
    listenId: String,
    userInterface: <UserInterface>null,
  },
  data () {
    this.userInterface.on('storage-reset', () => {
      this.paperListRecomputeCounter++;
    });

    Container.getPaperList().on('paper-list-update', () => {
      this.paperListRecomputeCounter++;
    });

    $(() => {
      $('#' + this.listenId).on('click', (e, options) => {
        options = options || {};

        bsModal('#general_settings_modal').show();

        if(options.tab && ['paper'].indexOf(options.tab) > -1) {
          Tab.getOrCreateInstance(document.querySelector('#gsm_tabbar_' + options.tab + '-tab')).show();
        }
      });

      $('#gsm_neighbour_overlap').on('change keyup input blur', function() {
        const newOverlap = parseInt($(this).val());
        Container.setNeighbourOverlap(newOverlap);
      });

    });

    const {coordinateSystemsInPanel: coordinateSystemsInPanel, dynamic: coordinateSystemsInPanelDynamic} = Container.getCoordinateSystemsInPanel();
    return {
      paperListRecomputeCounter: 0,
      container: Container,
      addingPaper: false,
      coordinateSystemsInPanel: coordinateSystemsInPanel,
      coordinateSystemsInPanelDynamic: coordinateSystemsInPanelDynamic,
    };
  },
  watch: {

  },
  computed: {
    CardinalDirections() {
      return CardinalDirections;
    },
    ElevationModeOptionLabels() {
      return ElevationModeOptionLabels;
    },
    paperList: function() {
      this.paperListRecomputeCounter;
      return Container.getPaperList().getPaperList();
    },
    neighbourOverlap: function() {
      return Container.getNeighbourOverlap();
    },
    defaultAdvancedSettingsMode: function() {
      return Container.getDefaultAdvancedSettingsMode();
    },
    defaultElevationMode: function() {
      return this.userInterface.getMap().defaultElevationMode;
    },
    cardinalDirectionsCount: function() {
      return Container.getCardinalDirectionsCount();
    },
    cardinalDirectionsLocale: function() {
      return Container.getCardinalDirectionsLocale();
    },
    cardinalDirectionsExampleSvg: function() {
      return Container.getReactiveProps().cardinalDirections.getExampleSvgString(200);
    },
    coordinateInSystems: function() {
      const preferredCoordinateSystem = Container.getPreferredCoordinateSystem();
      const preferredFormats = Container.getPreferredCoordinateFormats();

      const exampleCoordinate = new WGS84(6.745608, 51.940367);

      const coordinateSystemCodes = CoordinateConverter.getAllCoordinateSystems().map(cs => cs.code);
      coordinateSystemCodes.sort();

      const coordinateInSystems = [];
      for (const code of coordinateSystemCodes) {
        const coordinateSystem = CoordinateConverter.getCoordinateSystem(code);
        const converted = CoordinateConverter.convert(exampleCoordinate, coordinateSystem);
        const formats = converted.formats();
        const formatNames = Object.keys(formats);

        if(formatNames.length > 0) {
          let preferredFormatName;
          if(preferredFormats.hasOwnProperty(code) && formats.hasOwnProperty(preferredFormats[code])) {
            preferredFormatName = preferredFormats[code];
          } else {
            preferredFormatName = converted.defaultFormat();
          }

          const formatted: Record<string, string> = {};
          for(const formatName of formatNames) {
            formatted[formatName] = formats[formatName]();
          }

          coordinateInSystems.push({
            id: coordinateSystem.code.replace(/[^a-z0-9]/g, '_'),
            coordinate: converted,
            coordinateSystem: coordinateSystem,
            isPreferred: coordinateSystem.code === preferredCoordinateSystem.code,
            name: coordinateSystem.name,
            inCoordinatePanelSystems: this.coordinateSystemsInPanel.includes(coordinateSystem.code),
            formatted: formatted,
            preferredFormatName: preferredFormatName,
          });
        }
      }

      return coordinateInSystems;
    },
  },
  methods: {
    changeDefaultAdvancedSettingsMode(): void {
      Container.setDefaultAdvancedSettingsMode($('#gsm_default_advanced_settings_mode').prop('checked'));
    },
    changeDefaultElevationMode(): void {
      Container.setDefaultElevationMode($('#gsm_default_elevation_mode').val());
    },
    changeCardinalDirections(): void {
      Container.setCardinalDirectionsConfig(
          parseInt($('input[name="gsm_cardinal_directions_count"]:checked').val()),
          $('#gsm_cardinal_directions_locale').val(),
      );
    },
    isCustomPaper(paper: Paper): boolean {
      return paper instanceof CustomPaper;
    },
    addPaper() {
      this.addingPaper = true;
    },
    cancelAdd() {
      this.addingPaper = false;
    },
    saveAdd() {
      const $tr = $('#gsm-new-paper');

      const title = $tr.find('.gsm-paper-title').val();
      if(title.length < 1) {
        alert('Vul een naam in');
        return;
      }

      const width = $tr.find('.gsm-paper-width').val();
      if(!width || width < 50 || width > 2000 || !/^\d+$/.test(width)) {
        alert('Vul een breedte in tussen 50 en 2000 mm');
        return;
      }

      const height = $tr.find('.gsm-paper-height').val();
      if(!height || height < 50 || height > 2000 || !/^\d+$/.test(height)) {
        alert('Vul een hoogte in tussen 50 en 2000 mm');
        return;
      }

      // Larger then 1m^2 seems unreasonable. Do give some (1%) slack on this limit
      if(height * width > 1010000) {
        alert('Vul een breedte en hoogte in die samen niet meer dan één vierkante meter vormen');
        return;
      }

      const name = strSlug(title);
      if(Container.getPaperList().hasSystemPaper(name) || Container.getPaperList().hasCustomPaper(name)) {
        alert('Er bestaat al een papierformaat met deze naam, vul een andere in');
        return;
      }

      Container.getPaperList().addCustomPaper(new CustomPaper(
          parseInt(width),
          parseInt(height),
          title,
          name,
      ));

      this.addingPaper = false;
      $tr.find('input').each(function() {
        $(this).val('');
      });
    },
    deletePaper(paper: Paper) {
      if(confirm('Wil je dit papierformaat verwijderen?')) {
        Container.getPaperList().deleteCustomPaper(paper.name, this.userInterface);
      }
    },

    setPreferredCoordinateSystem(coordinateSystem: CoordinateSystem<Coordinate>) {
      Container.setPreferredCoordinateSystem(coordinateSystem);

      this.userInterface.recomputeObjectList();

      this.fetchCoordinateSystemsInPanel(); // In case 'dynamic' has now changed its content
      this.userInterface.recomputeCoordinatePanel();
    },
    setPreferredCoordinateFormatName(coordinate: Coordinate, formatName: string) {
      Container.setPreferredCoordinateFormatName(coordinate, formatName);

      this.userInterface.recomputeObjectList();
      this.userInterface.recomputeCoordinatePanel();
    },

    setCoordinateSystemInPanel(coordinateSystem: CoordinateSystem<Coordinate>, enable: boolean) {
      Container.setCoordinateSystemInPanel(coordinateSystem, enable);
      this.fetchCoordinateSystemsInPanel();
      this.userInterface.recomputeCoordinatePanel();
    },
    setCoordinateSystemsInPanelDynamic() {
      Container.setCoordinateSystemsInPanelDynamic(this.coordinateSystemsInPanelDynamic);
      this.fetchCoordinateSystemsInPanel();
      this.userInterface.recomputeCoordinatePanel();
    },
    fetchCoordinateSystemsInPanel() {
      const {coordinateSystemsInPanel, dynamic} = Container.getCoordinateSystemsInPanel();
      this.coordinateSystemsInPanel = coordinateSystemsInPanel;
      this.coordinateSystemsInPanelDynamic = dynamic;
    },

    clearCache() {
      if (confirm('De buffer bevat gedownloade kaartstukken. Wil je deze legen?')) {
        this.userInterface.showLoadingIndicator();
        Container.clearCaches().finally(() => {
          this.userInterface.hideLoadingIndicator();
        });
      }
    },
    resetStorage() {
      if (confirm('Wil je alle opgeslagen werkruimtes, sjablonen en andere voorkeuren verwijderen?')) {
        this.userInterface.showLoadingIndicator();
        Container.resetStorage();
        this.userInterface.trigger('storage-reset');
        this.userInterface.hideLoadingIndicator();
      }
    },
    resetApplication() {
      if (confirm('Wil je alle opgeslagen voorkeuren en buffers volledig verwijderen? Dit kan in sommige browsers even duren.')) {
        this.userInterface.showLoadingIndicator();
        Container.resetApplication().finally(() => {
          this.userInterface.hideLoadingIndicator();
        });
      }
    },
  }
};
</script>

<style scoped>

</style>
